const setPageTitle = (to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title + ' - GrowthInvest';
    }

    next();
};

export default setPageTitle;
